module.exports = __webpack_public_path__ + "static/media/tab-back.a6d01bec.png";